import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { hrmsGetRequest, hrmsPostRequest, hrmsUpdateRequest, hrmsDeleteRequest } from "../services/index";

const API_URL = "/api/arreasDetails"; // Matches backend route


export const fetchArreasDetails = createAsyncThunk("arreasDetails/fetch", async () => {
  const response = await hrmsGetRequest(API_URL);
  return response.data;
});


export const addArreasDetails = createAsyncThunk("arreasDetails/add", async (arreasData) => {
  const response = await hrmsPostRequest(API_URL, arreasData);
  return response.data;
});


export const updateArreasDetails = createAsyncThunk("arreasDetails/update", async ({ id, updatedData }) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}`, updatedData);
  return response.data;
});

export const deleteArreasDetails = createAsyncThunk("arreasDetails/delete", async (id) => {
  await hrmsDeleteRequest(`${API_URL}/${id}`);
  return id;
});

export const approveArreasDetails = createAsyncThunk("arreasDetails/approve", async (id) => {
  const response = await hrmsUpdateRequest(`${API_URL}/${id}/approve`, {});
  return response.data;
});

const arreasDetailsSlice = createSlice({
  name: "arreasDetails",
  initialState: {
    arreasDetails: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArreasDetails.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchArreasDetails.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.arreasDetails = action.payload;
      })
      .addCase(fetchArreasDetails.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      })
      .addCase(addArreasDetails.fulfilled, (state, action) => {
        state.arreasDetails.push(action.payload);
      })
      .addCase(updateArreasDetails.fulfilled, (state, action) => {
        const index = state.arreasDetails.findIndex((arreas) => arreas.id === action.payload.id);
        if (index !== -1) {
          state.arreasDetails[index] = action.payload;
        }
      })
      .addCase(deleteArreasDetails.fulfilled, (state, action) => {
        state.arreasDetails = state.arreasDetails.filter((arreas) => arreas.id !== action.payload);
      })
      .addCase(approveArreasDetails.fulfilled, (state, action) => {
        const index = state.arreasDetails.findIndex((arreas) => arreas.id === action.payload.id);
        if (index !== -1) {
          state.arreasDetails[index] = action.payload;
        }
      });
  },
});

export default arreasDetailsSlice.reducer;